module.exports = __webpack_public_path__ + "img/err.a825e343.png";